'use client'

import { clientOnlyDynamic } from '@/lib/client-only-dynamic'
import type { NextNewsInfiniteScrollProps } from '@/components/NextNewsInfiniteScroll'

const NextNewsInfiniteScroll = clientOnlyDynamic(
  () => import('@/components/NextNewsInfiniteScroll'),
)

/** İlk HTML’de yok; hidrasyondan sonra yüklenir ki sidebar sonraki haberi alsın. */
export default function LazyNextNewsInfiniteScroll(
  props: NextNewsInfiniteScrollProps,
) {
  return <NextNewsInfiniteScroll {...props} />
}
